import { generators, OauthRedirect, OauthRedirectRequest } from './generators';
import { APIResult } from 'utils/apidata';
import { call } from 'redux-saga/effects';
import { fetchIntegrations } from 'sagas/integrations';

export function* redirectToProvider(
  request: OauthRedirectRequest,
  response: APIResult<OauthRedirect>
) {
  if (response.success) {
    window.location.href = response.data.redirect_url;
  }
  yield null;
}

export const handleOauthRedirect = generators.handleOauthRedirect.saga(
  (api, { provider, signUpCode, hackeroneProgramHandle, hackeronePentestId }) =>
    call(api.post, `/api/v1/oauth/${provider}/login`, {
      signup_code: signUpCode,
      h1_program_handle: hackeroneProgramHandle,
      h1_pentest_id: hackeronePentestId,
    }),
  redirectToProvider
);

export const unlinkOauth = generators.unlink.saga(
  (api, { provider }) => call(api.del, `/api/v1/account/oauth/${provider}`),
  fetchIntegrations
);

export function* sagas() {
  yield handleOauthRedirect;
  yield unlinkOauth;
}
